export default __webpack_public_path__ + "static/media/card-league-icon.794a658c.png";